import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { trackDownloadClick } from '../services/analytics';

export default function Hero() {
  const ref = useScrollAnimation();

  return (
    <section
      ref={ref}
      className="fade-in mx-auto flex w-full max-w-6xl flex-col items-center gap-12 px-4 pb-16 pt-12 md:px-8 md:pt-20 lg:flex-row"
    >
      <div className="w-full lg:w-1/2">
        <h1 className="font-[Nunito] text-4xl leading-tight md:text-6xl">
          <span className="block font-semibold text-[#7B716A]">Potty training is hard.</span>
          <span className="block font-extrabold text-[#5B3FA6]">PottyPal makes it personal.</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#6F655E]">
          The only potty training app that learns your child's patterns and reminds you at exactly the right moment -
          not just every 2 hours.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            id="playstore"
            href="#playstore"
            onClick={() => trackDownloadClick('hero')}
            className="rounded-full bg-[#FF7B5B] px-6 py-3 text-center font-semibold text-white shadow-md transition hover:-translate-y-0.5"
          >
            Download Free on Android
          </a>
          <a
            href="#how-it-works"
            className="rounded-full border-2 border-[#5B3FA6] px-6 py-3 text-center font-semibold text-[#5B3FA6] transition hover:bg-[#F4F0FF]"
          >
            See How It Works
          </a>
        </div>
        <p className="mt-4 text-sm text-[#8A817B]">⭐⭐⭐⭐⭐ Trusted by 10,000+ parents</p>
      </div>

      <div className="relative w-full lg:w-1/2">
        <div className="mx-auto w-full max-w-xs rounded-[2.5rem] bg-[#1E1438] p-3 shadow-2xl">
          <div className="rounded-[2rem] bg-gradient-to-b from-[#6E4CC2] to-[#4B2F8F] p-6 text-white">
            <p className="text-sm opacity-80">Good morning, Sarah 👋</p>
            <h3 className="mt-4 font-[Nunito] text-xl font-bold">Next potty reminder</h3>
            <p className="mt-2 text-4xl font-extrabold tracking-wide">00:14:23</p>
            <div className="mt-8 rounded-2xl bg-white/15 p-3 text-sm">Pattern confidence: 89%</div>
          </div>
        </div>
        <span className="floating-badge left-0 top-8">🧠 AI-powered</span>
        <span className="floating-badge -right-2 top-28">🔔 Smart reminders</span>
        <span className="floating-badge bottom-8 left-2">👶 Child-friendly</span>
      </div>
    </section>
  );
}

